// Extracted from the web lap-brief dependency graph. Shared by API and web.
import { type MyChronGpsPoint } from './telemetrySession.js';
import { type MyChronLapRecord } from './telemetrySession.js';
import { type MyChronSessionExport } from './telemetrySession.js';
import { buildStartLineAtFraction } from './trackEnrichment.js';
import { resliceLapsAtStartLine } from './trackEnrichment.js';
export function buildMyChronLapsFromGps(
  gps: MyChronGpsPoint[],
  options?: { minLapDurationMs?: number; maxLapDurationMs?: number },
): MyChronLapRecord[] {
  if (gps.length < 12) {
    return [];
  }

  const fullTracePolyline = gps.map((point) => ({ lat: point.lat, lon: point.lon }));
  if (fullTracePolyline.length < 12) {
    return [];
  }

  const session: MyChronSessionExport = {
    format: 'gpx',
    channels: [],
    laps: [],
    gps,
    series: {},
    metadata: {},
  };

  const startLine = buildStartLineAtFraction(fullTracePolyline, 0);
  const reslice = resliceLapsAtStartLine(session, startLine, {
    referencePolyline: fullTracePolyline,
    minLapDurationMs: options?.minLapDurationMs ?? 15_000,
    maxLapDurationMs: options?.maxLapDurationMs ?? 240_000,
  });

  return reslice.laps
    .filter((lap) => lap.kind === 'flying')
    .map((lap) => ({
      segment: 0,
      lapNumber: lap.lapNumber,
      durationMs: Math.round(lap.durationSec * 1000),
      endTimeMs: Math.round(lap.endMs),
    }));
}
